import React from 'react';
import { Testimonials, Problem } from './Sections1';
import { Product, Bonuses } from './Sections2';
import { Pricing } from './Sections3';
import { Guarantee, FAQ, CostOfInaction, Footer } from './Sections4';
export function BelowFold() {
  return <>
      <Testimonials data-id="element-5" />
      <Problem data-id="element-6" />
      <Product data-id="element-7" />
      <Bonuses data-id="element-8" />
      <Pricing data-id="element-9" />
      <Guarantee data-id="element-10" />
      <FAQ data-id="element-11" />
      <CostOfInaction data-id="element-12" />
      <Footer data-id="element-13" />
    </>;
}